module.exports = __webpack_public_path__ + "bginside.b0f49510f0f3021435fc.jpg";


//////////////////
// WEBPACK FOOTER
// A:/Work/Siti/Volpe2/src/app/themes/default/images/bginside.jpg
// module id = ../../../../../src/app/themes/default/images/bginside.jpg
// module chunks = 1